(function() {
$.getJSON( "https://cors.shaungill.co.uk/?url=https://www.staffs-wildlife.org.uk/feed/events/tttv", function( json ) {} )
.done(function( data ) {
   $.each( data, function( i, item ) {

      if(item.field_event_time.length !== 0) {
         // If event is using the 'field_event_time' field
         eventTime = item.field_event_time[0].value;
      } else {
         if(item.field_event_time_value.length !== 0) {
            // If event is using the 'field_event_time_value' field, use to and from timestamps and convert to time
            eventTime = $.time(item.field_event_time_value[0].from) + ' to ' + $.time(item.field_event_time_value[0].to);
         } else {
            // If event is using neither, skip this event
            return;
         }
      }

      html = '<div class="pv-20 ph-20 hc-item-box-2 boxed hc-shadow hc-element-invisible animated hc-element-visible fadeInDownSmall" data-animation-effect="fadeInDownSmall" data-effect-delay="100">';
                  html += '<span class="icon without-bg"><i class="fa fa-ticket text-default"></i></span>';
                  html += '<div class="body">';
                  html += '<h4 class="title"><strong class="text-default">'+ item.title[0].value +'</strong></h4>';
                  html += '<p class="title"><i class="fa fa-calendar text-default pr-2"></i><strong> ' + $.date(item.field_event_date[0].value) + ' <i class="fa fa-clock-o text-default pl-10"></i> ' + eventTime + '</strong></p>';
                  html += '<p>'+ item.field_event_summary[0].value +'</p>';
                  html += '<p>'+ item.field_event_about[0].value +'</p>';
                  html += '<p><a href="https://www.staffs-wildlife.org.uk/node/' + item.nid[0].value + '" class="btn btn-animated btn-default btn-sm" target="_blank">Book Online <i class="fa fa-external-link"></i></a> via <a href="https://www.staffs-wildlife.org.uk/events?tags=398" target="_blank">Staffordshire Willdife Trust</a></p>';
                  html += '</div>';
                  html += '</div>';

      $( ".bsb-events" ).append( html );
   });
});

$.date = function(dateObject) {
   var d = new Date(dateObject);
   var dayDate = d.getDate();
   var day = d.getDay();
   var month = d.getMonth();
   var year = d.getFullYear();
   
   days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
   months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

   var date = days[day] + " " + dayDate + " " + months[month] + " " + year;
   return date;
};

$.time = function(timeObject) {
 var a = new Date(timeObject * 1000);
 var hour = a.getUTCHours();
 var min = (a.getUTCMinutes() < 10) ? ('0' + a.getUTCMinutes()) : a.getUTCMinutes();
 var time = hour + ':' + min;
 return time;
}

})();